import React from "react";
import {
  SOFTWARE_TYPE_MOBILE,
  SOFTWARE_TYPE_PC,
} from "../../utils/softVersionClientTypeUtils";

export function ReportsVersionField({
  value,
  onChange,
  onFocus,
  softwareTypeMode = SOFTWARE_TYPE_PC,
  onSoftwareTypeModeChange,
}) {
  const setMode = (mode) => {
    if (mode === softwareTypeMode) {
      return;
    }
    onSoftwareTypeModeChange?.(mode);
  };

  return (
    <label className="reports-version-field">
      <span className="site-form-label">Версия (стационар, mobile)</span>
      <div className="reports-version-wrapper">
        <input
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          className="reports-version-input site-form-control"
          type="text"
          inputMode="decimal"
          autoComplete="off"
          spellCheck={false}
          aria-label="Версия программного обеспечения"
        />
        <div className="software-type-switcher" role="group" aria-label="Тип софта">
          <button
            type="button"
            className={`switcher-btn${
              softwareTypeMode === SOFTWARE_TYPE_PC ? " active" : ""
            }`}
            data-type="pc"
            aria-pressed={softwareTypeMode === SOFTWARE_TYPE_PC}
            onClick={() => setMode(SOFTWARE_TYPE_PC)}
          >
            PC
          </button>
          <button
            type="button"
            className={`switcher-btn${
              softwareTypeMode === SOFTWARE_TYPE_MOBILE ? " active" : ""
            }`}
            data-type="m"
            aria-pressed={softwareTypeMode === SOFTWARE_TYPE_MOBILE}
            onClick={() => setMode(SOFTWARE_TYPE_MOBILE)}
          >
            M
          </button>
        </div>
      </div>
    </label>
  );
}
